export const getFactDutyFilter = (
  startHourInterval: string,
  endHourInterval: string,
  department: string,
  staffQual: string[]
): string => {
  return [
    '(staff_ref.date_end =is= empty)', // Фильтр по НЕ уволенным сотрудникам
    `(duty_type_plan_ref.code_id=="А")`,
    `(duty_start_plan=le=${startHourInterval})`,
    `(duty_end_plan=ge=${endHourInterval})`,
    department ? `(staff_ref.comment=="${department}")` : undefined,
    staffQual.length > 0 ? `staff_ref.staff_qual=contain=(${staffQual.join(',')})` : undefined,
  ]
    .filter(Boolean)
    .join(';')
}
